module.exports = __webpack_public_path__ + "static/media/logic.52e256c3.svg";